<div class="main-content">
    <div class="container-fluid">
        <div class="justify-content-center row">
            <div class="col-12">
                <div class="header">
                    <div class="header-body">
                        <div class="align-items-center row">
                            <div class="col">
                                <h6 class="header-pretitle">Overview</h6>
                                <h1 class="header-title text-truncate">Alerts</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
                    <div class="header-bar align-items-center mb-4">
                        <div class="row gx-3 mb-3">
                            <div class="col-auto d-flex d-md-none px-1">
                                <button class="btn text-black p-0 btn-close-wrapper border-0 rounded-circle"
                                        (click)="openFiltersInModal()"
                                        [style.width.px]="40" [style.height.px]="40"
                                        [ngClass]="facetUtils.hasActiveFilters(facetFilters) ? 'active': ''">
                                    <span class="bi bi-filter m-0 h1"></span>
                                </button>
                            </div>
                            <div class="col">
                                <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
                            </div>
                            <div class="col" style="max-width: 300px;">
                                <app-date-range localStorageKey="alerts-overview-range" [(ngModel)]="dateRange" [ranges]="ranges"
                                                (ngModelChange)="executeQuery()"></app-date-range>
                            </div>
                            <div class="col-auto ms-auto d-flex flex-row align-items-center">
                                <button (click)="toggleSelection()" type="button" class="btn btn-secondary">
                                    <i class="bi bi-pencil me-md-2"></i>
                                    <span class="d-none d-md-inline">Bulk edit</span>
                                </button>
                            </div>
                            <div *ngIf="appContext.isAdmin()" class="col-auto">
                                <button (click)="addAlert()" type="button" class="btn btn-primary">
                                    <i class="bi bi-plus me-md-2"></i>
                                    <span class="d-none d-md-inline">Add alert</span>
                                </button>
                            </div>
                            <div class="col-auto">
                                <div class="dropdown">
                                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                        <i class="bi bi-download me-md-2"></i>
                                        <span class="d-none d-md-inline">Download</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <button class="dropdown-item" (click)="downloadAlertsAsExcel()">Alerts list
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row d-none d-md-flex">
                            <div class="col">
                                <ng-template [ngTemplateOutlet]="facetsTemplate"
                                             [ngTemplateOutletContext]="{ $implicit: 'top' }"></ng-template>
                            </div>
                        </div>
                        <div class="row mb-3 d-flex justify-content-end" *ngIf="selecting">
                            <div class="col-12">
                                <div class="form-check form-switch ms-2">
                                    <input class="form-check-input mt-0" [checked]="allItemsSelected()"
                                           (click)="toggleSelectAll()" type="checkbox" id="select-all">
                                    <label class="form-check-label" for="select-all">
                                        <span *ngIf="allItemsSelected()">Deselect all</span>
                                        <span *ngIf="!allItemsSelected()">Select all</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview-items pb-4">
                        <div class="row mx-0">
                            <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                                <app-alert-overview-item [alertEntity]="record"
                                                         [selecting]="selecting"></app-alert-overview-item>
                            </ng-container>
                        </div>
                    </div>
                    <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
                        <span class="h1 mb-2">No alerts found</span>
                        <span class="text-secondary">Try adjusting your filters or search term</span>
                    </div>
                </app-overview>
                <div class="sticky-bottom bg-white mx-n3 mx-md-n5 border-top" *ngIf="selecting">
                    <app-alert-selection *ngIf="selecting" [selectedItems]="selectedItems"
                                         [cancelMethod]="toggleSelection"></app-alert-selection>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #filtersInModal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header">
                <h3 class="card-header-title">
                    <i class="bi bi-filter me-2"></i>
                    <span>Filters</span>
                </h3>
            </div>
            <div class="card-body">
                <div class="position-relative w-100">
                    <ng-template [ngTemplateOutlet]="facetsTemplate"
                                 [ngTemplateOutletContext]="{ $implicit: 'left' }"></ng-template>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between">
                    <a class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #facetsTemplate let-position>
    <app-facets-overview [query]="facets" (facetFiltersChange)="facetFilters = $event" [hiddenFacets]="hiddenFacets"
                         (onUpdate)="executeQuery()" localStorageKey="alerts-overview-facets" [facetNameFormatter]="facetNameFormatter"
                         [getValueFormatter]="getFacetValueFormatter" [getTranslateValues]="getTranslateValues"
                         [defaultFacetFilters]="defaultFacetFilters" [position]="position" [selectedFacets]="facetFilters"></app-facets-overview>
</ng-template>